import React from 'react'
import {Lang} from 'yougile-lang'
import {Icon} from '@components/common/base/icon'

export const PermissionsSettingsDisallowed = () => (
  <div className="p-8 flex gap-8 items-center">
    <Icon icon="IconAlertTriangleFilled" color="status-error" size={32} />
    <span className="flex-1 text-sm-regular text-primary">
      {Lang.msg.permission.noEditObject}
    </span>
  </div>
)
